import React from 'react';
import { Link } from 'react-router-dom';
import courseData from '../data/courseData';
import LessonCard from '../components/LessonCard';
import { useProgress } from '../hooks/useProgress';

const HomePage = () => {
  const { calculateOverallProgress } = useProgress();
  const progressPercentage = calculateOverallProgress(courseData.length);

  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-content">
          <h1>Ink Drawing for Beginners</h1>
          <p>Master the art of ink drawing through 10 comprehensive lessons</p>
          <div className="hero-buttons">
            <Link to="/lesson/1" className="btn-primary">Start Learning</Link>
            <Link to="/about" className="btn-secondary">About the Course</Link>
          </div>
        </div>
      </section>

      <section className="course-overview">
        <div className="section-header">
          <h2>Course Progress</h2>
          <div className="progress-container">
            <div className="progress-text">{progressPercentage}% Complete</div>
            <div className="progress-bar">
              <div 
                className="progress-fill" 
                style={{ width: `${progressPercentage}%` }}
              ></div>
            </div>
          </div>
        </div>

        <div className="lessons-grid">
          {courseData.map(lesson => (
            <Link to={`/lesson/${lesson.id}`} key={lesson.id} className="lesson-link">
              <LessonCard lesson={lesson} />
            </Link>
          ))}
        </div>
      </section>

      <section className="course-features">
        <h2>Course Features</h2>
        <div className="features-grid">
          <div className="feature-card">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24" width="48" height="48">
                <path fill="currentColor" d="M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
              </svg>
            </div>
            <h3>Comprehensive Techniques</h3>
            <p>Learn all essential ink drawing techniques from basic to advanced</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24" width="48" height="48">
                <path fill="currentColor" d="M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z" />
              </svg>
            </div>
            <h3>Downloadable Resources</h3>
            <p>Practice with printable worksheets and reference guides</p>
          </div>
          <div className="feature-card">
            <div className="feature-icon">
              <svg viewBox="0 0 24 24" width="48" height="48">
                <path fill="currentColor" d="M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z" />
              </svg>
            </div>
            <h3>Progress Tracking</h3>
            <p>Track your progress and pick up where you left off</p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
